// components/OrganizationSlider.jsx
import React, { useEffect, useRef, useState } from 'react';
import { getOrganPicture } from '../../services/postService';
import { imgBaseUrl } from '../../utils/api';
import './OrganizationSlider.css';

const OrganizationSlider = () => {
  const [organizations, setOrganizations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const sliderRef = useRef(null);
  const containerRef = useRef(null);

  const getImageUrl = (imageName) => {
    if (!imageName) return "";
    const src = String(imageName);
    if (/^https?:/i.test(src)) return src;
    const base = (imgBaseUrl || "").replace(/\/$/, "");
    const normalized = src.replace("http://10.20.30.12:92/", "").replace(/^\//, "");
    return base ? `${base}/${normalized}` : `/${normalized}`;
  };

  useEffect(() => {
    const loadOrganizations = async () => {
      try {
        setIsLoading(true);
        const data = await getOrganPicture();
        setOrganizations(data || []);
      } catch (error) {
        console.error('Error loading organization slides:', error);
        setOrganizations([]);
      } finally {
        setIsLoading(false);
      }
    };

    loadOrganizations();
  }, []);

  // Initialize flickity after organizations are loaded
  useEffect(() => {
    if (isLoading || organizations.length === 0) return;

    const isSliderActive = organizations.length >= 5;
    
    // Show/hide container based on data
    if (containerRef.current) {
      containerRef.current.style.display = organizations.length > 0 ? 'block' : 'none';
    }

    // Initialize flickity only for slider mode
    if (isSliderActive && sliderRef.current) {
      const $ = window.jQuery || window.$;
      if ($?.fn?.flickity) {
        const $slider = $(sliderRef.current);
        
        // Destroy existing instance if any
        if ($slider.data('flickity')) {
          $slider.flickity('destroy');
        }

        // Initialize new flickity
        $slider.flickity({
          wrapAround: true,
          cellAlign: "right",
          contain: true,
          pageDots: false,
          prevNextButtons: false,
          rightToLeft: true,
          imagesLoaded: true,
          lazyLoad: true,
          groupCells: 1,
          draggable: true,
          autoPlay: 3000,
          selectedAttraction: 0.015,
          friction: 0.4,
        });
      }
    }
  }, [organizations, isLoading]);

  const getGridClass = (count) => {
    switch(count) {
      case 1: return 'single-grid';
      case 2: return 'double-grid';
      case 3: return 'triple-grid';
      case 4: return 'four-grid';
      default: return '';
    }
  };

  const renderCards = () => {
    const count = organizations.length;
    const isSliderActive = count >= 5;

    if (isSliderActive) {
      // Slider mode - render as direct children of slider div
      return organizations.map((org, index) => (
        <div key={index} className="main__slider__cell_organ">
          <a 
            href={org.link} 
            target="_blank" 
            rel="noopener noreferrer"
            className="organization-card"
          >
            <div className="card-image">
              <img 
                src={getImageUrl(org.imageUrl)} 
                alt={org.title || 'سازمان'}
                loading="lazy"
              />
            </div>
            <div className="card-title">
              {org.title || ''}
            </div>
          </a>
        </div>
      ));
    } else {
      // Static grid mode
      return (
        <div className={`organization-static-grid ${getGridClass(count)}`}>
          {organizations.map((org, index) => (
            <div key={index} className="organization-grid-item">
              <a 
                href={org.link} 
                target="_blank" 
                rel="noopener noreferrer"
                className="organization-card"
              >
                <div className="card-image">
                  <img 
                    src={getImageUrl(org.imageUrl)} 
                    alt={org.title || 'سازمان'}
                    loading="lazy"
                  />
                </div>
                <div className="card-title">
                  {org.title || ''}
                </div>
              </a>
            </div>
          ))}
        </div>
      );
    }
  };

  if (isLoading) {
    return (
      <section className="organization__slider__sec">
        <div className="container">
          <div className="loading-spinner">در حال بارگذاری...</div>
        </div>
      </section>
    );
  }

  if (organizations.length === 0) {
    return null; // Don't render anything if no data
  }

  return (<>
  <div class="mimt__head">
                            <h4 class="mimt__head__title">شرکت های تابعه</h4>
                        </div>
                        
    <section className="organization__slider__sec" ref={containerRef}>
      <div className="container">
        {/* <div className="mimt__head">
          <h4 className="mimt__head__title">سازمان‌های مرتبط</h4>
        </div> */}
        <div 
          className={`organization__slider ${organizations.length >= 5 ? 'flickity-enabled' : ''}`} 
          ref={sliderRef}
        >
          {renderCards()}
        </div>
      </div>
    </section>
    </>
  );
};

export default OrganizationSlider;